/**
 * @(#)2020/03/16.
 * YxUpload，用于上传数据 -华为云逻辑
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import BaseUpload from "../BaseUpload";
import { ossValueFromHandle } from "../tools";
import { YxComponent } from "../../../YxComponent";
import { get, random, merge, toArray } from "../../../../utils";
import UploadFileHuawei from "../../../../utils/upload/uploadFileHuawei";
import { urlToFile } from "../../../../utils/upload/uploadFile";
/**
 * 华为云上传
 *
 * @class UploadHuawei
 * @extends {YxComponent}
 */
class UploadHuawei extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.uploadFile = get(
      this.props,
      "uploadFile",
      new UploadFileHuawei(this.props)
    );
    this.id = random();
  }

  get extraUploadParam() {
    return {};
  }

  beforeUploadExtraAction = async (file) => {
    const fileType = get(file, "type", "image/png");
    await this.uploadFile.getSign(fileType);
  };

  /**
   * 获得凭证
   *
   * @param {object} props
   * @memberof UploadHuawei
   */
  getSign = async (setState, ossFactory) => {
    let props = this.props;
    setState({ spin: true });
    const isRead = get(props, "isRead", false);
    const propsList = toArray(get(props, "list", []));
    const list = propsList.slice(0, props.limit || undefined);
    const fileList = list.map((url, index) => urlToFile(url, -index));
    const baseObj = { fileList, spin: false };
    if (isRead) {
      setState(baseObj);
    } else {
      await this.parseConfig(setState, baseObj);
    }
  };
  parseConfig = (setState, baseObj) => {
    return new Promise((resolve) => {
      this.uploadFile
        .getSign()
        .then((config) => {
          this.setState({ ossUrl: config.host });
          setState({ ...baseObj }, resolve);
        })
        .catch((err) => {
          setState({ spin: false }, resolve);
        });
    });
  };

  /**
   * 每个云实现自己的url转换逻辑
   * 直接决定表单的值和展示出来的图片
   *
   * @param {File} {file,fileList，uploadFormList}
   * @returns (urls fullUrls)
   * @memberof UploadOss
   */
  getValueFromHandle = ({ filterList, uploadFormList }) => {
    const obsUrl = this.uploadFile.uploadFileUrl;
    return ossValueFromHandle(obsUrl, filterList, uploadFormList);
  };

  get param() {
    const result = {
      getSign: this.getSign,
      uploadFile: this.uploadFile,
      extraUploadParam: this.extraUploadParam,
      uploadUrl: this.uploadFile.uploadFileUrl,
      getValueFromHandle: this.getValueFromHandle,
      beforeUploadExtraAction: this.beforeUploadExtraAction,
    };
    return merge(result, this.props);
  }

  render() {
    return <BaseUpload {...this.param} />;
  }
}

export default UploadHuawei;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Upload-huawei/index.js